/**
 * Collection Online Seminars Carousel
 * Uses shared initScrollSnapCarousel from utils.js
 */

(function () {
  "use strict";

  function init() {
    initScrollSnapCarousel({
      sectionSelector: ".collection-online-seminars",
      containerSelector: ".collection-online-seminars__products-container",
      itemsContainerSelector: "#collection-online-seminars-products-{sectionId}",
      itemSelector: ".collection-online-seminars__product-item",
      paginationSelector: "#collection-online-seminars-pagination-{sectionId}",
      dotClass: "collection-online-seminars__pagination-dot",
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
